// extracted by mini-css-extract-plugin
export default {"slideUpFade":"Animation_slideUpFade__JQqPM"};